import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "junk-drawer",
  "use": "junk-drawer-usage",
  "viewBox": "0 0 46 16",
  "content": "<symbol viewBox=\"0 0 46 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"junk-drawer\"><path d=\"M0 2h28V0H0zM0 9h28V7H0zM0 16h28v-2H0zM36 7l5 5 5-5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/junk-drawer.svg
// module id = 1548
// module chunks = 0